import api from "../services/apiConfig";

export const authService = {
  login: async (email, password) => {
    try {
      const response = await api.post("api/users/login/", {
        email,
        password,
      });
      if (response.data.data.access) {
        localStorage.setItem("token", response.data.data.access);
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  signup: async (data) => {
    try {
      const response = await api.post("api/users/registration/", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  verifyCode: async (email, code) => {
    try {
      const response = await api.post("api/users/verify-verification-code/", {
        email,
        verification_code: code,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resendCode: async (email) => {
    try {
      const response = await api.post("api/users/resend-verification-code/", {
        email,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await api.post("api/users/generate-code/", { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  verifyOtp: async (email, otp) => {
    try {
      const response = await api.post("api/users/validate-code/", {
        email,
        code: otp,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (email, newPassword) => {
    try {
      const response = await api.post("api/users/reset-password/", {
        email,
        password: newPassword,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUserProfile: async () => {
    try {
      const response = await api.get("api/users/profile/retrieve/");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  checkAuth: async (access) => {
    try {
      const response = await api.post("api/users/check-auth/", { access });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  logout: async (access) => {
    try {
      const response = await api.post("api/users/logout/", { access });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resendTimeout: async (email) => {
    try {
      const response = await api.get("api/users/get-next-otp-time/", { params: { email }});
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
